import React, { useEffect, useState } from "react";
import "./financialPerformance.scss";
import {
  InvestorBgImg,
  InvestorFgImg,
  textilesProspectus,
  file1,
  file4,
  file7,
  file28,
  file29,
  file2,
  file5,
  file8,
  file3,
  file6,
  file9,
  finanQu2File1,
  finanQu2File2,
  finanQu2File3,
  finanQu2File4,
  earningsCall,
  finanQu2File6,
  finanQu3board,
  finanQu3InvestorMeet,
  finanQu3OutCome,
  finanQu3Press,
  finanQu3Insider,
  finanQu3Statement,
  finanQu3EarningsCall,
  finanQu3EarningsTrans,
  finanQu3StlInvest,
  finanQu3StlSigned,
  finanQu4StlMagazineMar25,
  finanQu4STLIntimationReg30,
  finanQu4WebsiteFilings,
  earningsCall2025,
  Sanathan_STL_Cover,
  Sanathan_Cover_Investor_Mar2025,
  SPPLFinancialStatementsMar2025,
  UTPLFinancialStatMar2025,
  UTPLFinancialStatementsMar2025,
  STLAGMNotice,
  STLAnnualReports,
  STLDraftMGT20242025,
  STLPredispatchAdv,
  STLNewspaperCovering,
  STLCoveringforProceedings,
  STLCoveringforVoting,
  STL_20thAGM_Transcription,
  STLInvestorsMeetJune10,
  STLInvestorsMeet11062025,
  STLInvestorsMeetJune12,
  STLInvestorsMeetJune25,
  STLTradingWindowclosureintimation,
  STLCertificateReg74,
  STLMonitoringagencyreport,
  STLBMIntimation07082025,
  STLBMOutcome07082025,
  STLCoverLetterforEarningsCall,
  STLInvestorpresentation,
  callRec10034845,
  CommencementProductionPunjab,
  quarter2526_1,
  quarter2526_2,
  quarter2_2526_1,
  quarter2_2526_2,
  quarter2_2526_3,
  quarter2_2526_4,
  quarter2_2526_5,
  quarter2_2526_6,
  quarter2_2526_7,
  quarter2_2526_8,
  quarter2_2526_9,
  quarter2_2526_10,
  quarter2_2526_11,
  quarter2_2526_12,
  quarter2_2526_14,
  quarter2_2526_13,
  quarter2_2526_15,
  finanQu3FileOne,
  finanQu3FileTwo,
  finanQu2EarCallTrans,
  PressReleaseQ3FY25,
  intimationOnClosureofTradingWindow,
  certificateUnder74,
  IntimationOfBoardMeetingQ3FY,
  IntimationOfEarningsCallQ3FY,
  IntimationOfAnalystMeet,
  OutcomeOfBoardMeeting_Feb,
  FinancialResults,
  MonitoringAgencyReport,
  earningsCallAudioRecording_3FY26,
  STLinvestorsMeet19022026,
  AcqSerentica2026,
  CertRTAReg74_2026,
  Phase1RampUp2026,
  CreditRatingMar24_2026,
  PriorIntimationBM2026,
  ReconShareCapAudit2026,
  IntimationEarningsCall2026,
  TradingWindowClosure2026,
  CreditRatingDec29_2025,
  AnnualComplianceReport2025,
  AnnualComplianceReport2026,
  outcomeOfBoardMeeting2026,
  financialResults2026,
  earningsCallAudioRecording_Q4FY26,
  Q4_Investor_Presentation,
  finalMonitoringAgencyReport,
  pressReleaseMay152026,
  newspaperPublicationAuditedFinancialResults,
  investUpArrow,
  MediaAnalystBriefingNote2026,
  STLFInancialsConsolidatedMarch2026,
  STLFinancialStandealoneMarch2026,
  SPPLFinancialMarch2026,
  UTPLFinancialMarch2026,
  IntimationofAnalystMeetJune,
  ClosureofTradingWindow,
  CertificateofRTAunderRegulation,
  ReconciliationofShareCapitalAuditReport,
  IntegratedCorporateGovernance,
  priorIntimationBoardMeeting,
  pressReleaseSilvassa,
  outcomeofBoardMeetingAugust032026,
  financialResultsQ1FY27,
  pressReleaseAugust032026,
  newspaperPublicationQ1FY27,
  investorPresentationQ1FY27,
  earningsCallRecordingQ1FY27,
  appointmentofStatutoryAuditors,
  sanathanTextilesAnnualReport2026,
  creditRating17082026,
  preDispatchNewspaperpublicationAGM,
  PostDispatchNewspaperpublicationAGM,
  sanathanTextilesCommercialAtSilvassa,
  investorsMeet26082026,
  intimationEarningsCallQ1FY27,
  earningsCallTranscriptQ1FY27,
  noticeofAGM2026,
  businessResponsibilityReporting,
  sanathanPolycot,
  VotingResultsandScrutinizers21stAGM,
  Proceedingsof21stAGM,
  InvestorsMeet01092026,
  InvestorsMeet09092026,
  InvestorsMeet11092026,
  STLReappointmentIndependentDirectos,
  closureTradingWindow01,
  certificateRTAUnderRegulation74501,
  reconciliationShareCapitalAuditReport01,
  IntimationofEarningsCallQ2FY27,
  PriorIntimationofBoardMeeting01,
} from "../../images";
import { Link } from "react-router-dom";
import Dash from "../../components/Dash/Dash";
import FinanceAcc from "../../components/FinanceAcc/FinanceAcc";
import InvestTab from "../../components/InvestTab/InvestTab";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import InvestAcc from "../../components/InvestAcc/InvestAcc";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";
import Stock from "../../components/StockIndicator/Stock";

const tabTopData = [
  {
    id: 1,
    title: "Corporate Governance",
    link: "/investor-relations/corporate-governance#corporate",
  },
  {
    id: 2,
    title: "Financial Performance & Presentation",
    link: "/investor-relations/financial-performance#financial",
  },
];

const tabBottomData = [
  // {
  //   id: 3,
  //   title: "Annual Reports",
  //   link: "/investor-relations/annual-reports#annual",
  // },
  {
    id: 4,
    title: "Announcements",
    link: "/investor-relations/announcements#announcement",
  },
  {
    id: 5,
    title: "Shareholding Pattern",
    link: "/investor-relations/shareholding-pattern#shareholding",
  },
  {
    id: 6,
    title: "Intimation of Investor Meet",
    link: "/investor-relations/investor-meet-presentation#intimation",
  },
  {
    id: 7,
    title: "Investor Contacts",
    link: "/investor-relations/investor-contacts#investor",
  },
  {
    id: 8,
    title:
      "Disclosures under Regulation 46 and 62 of SEBI (LODR) Regulations, 2015",
    link: "/investor-relations/disclosures-under-regulation-46-and-62-of-sebi-lodr-regulations-2015#disclosure",
  },
];

const financialPerformanceAnual = [
  {
    id: 5,
    mainTitle: "2025-2026",
    url: "2025-26",
    data: [
      {
        title: "Proceedings of 21st AGM",
        link: Proceedingsof21stAGM,
      },
      {
        title: "Voting Results and Scrutinizers Report of 21st AGM",
        link: VotingResultsandScrutinizers21stAGM,
      },
      {
        title: "Notice of AGM_ 2026",
        link: noticeofAGM2026,
      },
      {
        title: "Business Responsibility and Sustainability Reporting",
        link: businessResponsibilityReporting,
      },
      {
        title: "Sanathan Polycot",
        link: sanathanPolycot,
      },
      {
        title: "Sanathan Textiles - Annual Report - FY 2026",
        link: sanathanTextilesAnnualReport2026,
      },
      {
        title: "Sanathan Textiles – Consolidated for March 2026",
        link: STLFInancialsConsolidatedMarch2026,
      },
      {
        title: "Sanathan Textiles – Standalone for March 2026",
        link: STLFinancialStandealoneMarch2026,
      },
      // {
      //   title: "Sanathan Polycot",
      //   link: SPPLFinancialMarch2026,
      // },
      {
        title: "Universal Texturisers",
        link: UTPLFinancialMarch2026,
      },
      {
        title: "Annual Secretarial Compliance Report - 2026",
        link: AnnualComplianceReport2026,
      },
    ],
  },
  {
    id: 1,
    mainTitle: "2024-2025",
    url: "2024-25",
    data: [
      {
        title: "Annual Secretarial Compliance Report 2025",
        link: AnnualComplianceReport2025,
      },
      {
        title: "SPPL Financials 2025",
        link: SPPLFinancialStatementsMar2025,
      },
      {
        title: "UTPL Financials 2025",
        link: UTPLFinancialStatMar2025,
      },
      {
        title: " Annual Return 2025",
        link: STLDraftMGT20242025,
      },
      {
        title: "Notice of AGM_2025",
        link: STLAGMNotice,
      },
      {
        title: "Annual Report_2025",
        link: STLAnnualReports,
      },
      {
        title: "Pre-dispatch Advertisement",
        link: STLPredispatchAdv,
      },
      {
        title: "Post-dispatch Advertisement",
        link: STLNewspaperCovering,
      },
      {
        title: "Proceedings of 20th AGM",
        link: STLCoveringforProceedings,
      },
      {
        title: "Voting Results of 20th AGM",
        link: STLCoveringforVoting,
      },
      {
        title: "Transcript of 20th AGM",
        link: STL_20thAGM_Transcription,
      },
      {
        title: "20th AGM of the Company",
        type: "external",
        link: "https://youtu.be/kGapafvuC3s",
        yt: true,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "2023-2024",
    data: [
      {
        title: "STL Financials 2024",
        link: file1,
      },
      {
        title: "SPPL Financials 2024",
        link: file4,
      },
      {
        title: "UTPL Financials 2024",
        link: file7,
      },
      {
        title: "STL Annual Return 2024",
        link: file28,
      },
      {
        title: "SPPL Annual Return 2024",
        link: file29,
      },
    ],
  },
  {
    id: 3,
    mainTitle: "2022-2023",
    data: [
      {
        title: "STL Financials 2023",
        link: file2,
      },
      {
        title: "SPPL Financials 2023",
        link: file5,
      },
      {
        title: "UTPL Financials 2023",
        link: file8,
      },
    ],
  },
  {
    id: 4,
    mainTitle: "2021-2022",
    data: [
      {
        title: "STL Financials 2022",
        link: file3,
      },
      {
        title: "SPPL Financials 2022",
        link: file6,
      },
      {
        title: "UTPL Financials 2022",
        link: file9,
      },
    ],
  },
];

const financialPerformance2627 = [
  {
    id: 3,
    mainTitle: "Quarter 3",
    data: [
      {
        title: "STL Re-appointment of Independent Directors",
        link: STLReappointmentIndependentDirectos,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 2",
    data: [
      {
        title: "Prior Intimation of Board Meeting",
        link: PriorIntimationofBoardMeeting01,
      },
      {
        title: "Intimation of Earnings Call Q2FY27",
        link: IntimationofEarningsCallQ2FY27,
      },
      {
        title: "Closure of Trading Window",
        link: closureTradingWindow01,
      },
      {
        title: "Certificate of RTA under Regulation 74(5)",
        link: certificateRTAUnderRegulation74501,
      },
      {
        title: "Shareholding Pattern",
        link: "/shareholding-pattern-2026-27.html",
        type: "external",
      },
      {
        title: "Reconciliation of Share Capital Audit Report",
        link: reconciliationShareCapitalAuditReport01,
      },
      {
        title: "Investors Meet 01.09.2026",
        link: InvestorsMeet01092026,
      },
      {
        title: "Investors Meet 09.09.2026",
        link: InvestorsMeet09092026,
      },
      {
        title: "Investors Meet 11.09.2026",
        link: InvestorsMeet11092026,
      },
      {
        title: "Credit Rating 17.08.2026",
        link: creditRating17082026,
      },
      {
        title: "Pre Dispatch Newspaper publication for AGM",
        link: preDispatchNewspaperpublicationAGM,
      },
      {
        title: "Post Dispatch Newspaper publication for AGM",
        link: PostDispatchNewspaperpublicationAGM,
      },
      {
        title:
          "Sanathan Textiles announces Commercial Production from Expanded Technical Textiles Capacity at Silvassa",
        link: sanathanTextilesCommercialAtSilvassa,
      },
      {
        title: "Investors Meet 26.08.2026",
        link: investorsMeet26082026,
      },
      {
        title:
          "Press Release- Sanathan Textiles on track to double Technical Textiles Capacity at Silvassa",
        link: pressReleaseSilvassa,
      },
    ],
  },
  {
    id: 1,
    mainTitle: "Quarter 1",
    data: [
      {
        title: "Intimation of Earnings Call Q1FY27",
        link: intimationEarningsCallQ1FY27,
      },
      {
        title: "Earnings Call Transcript Q1FY27",
        link: earningsCallTranscriptQ1FY27,
      },
      {
        title: "Financial Results - Q1FY27",
        link: financialResultsQ1FY27,
      },
      {
        title: "Outcome of Board Meeting - August 03, 2026",
        link: outcomeofBoardMeetingAugust032026,
      },
      {
        title: "Appointment of Statutory Auditors",
        link: appointmentofStatutoryAuditors,
      },
      {
        title: "Press Release - August 03, 2026",
        link: pressReleaseAugust032026,
      },
      {
        title: "Newspaper Publication - Un-Audited Financial Results - Q1FY27",
        link: newspaperPublicationQ1FY27,
      },
      {
        title: "Investor Presentation - Q1FY27",
        link: investorPresentationQ1FY27,
      },
      {
        title: "Earnings Call Audio Recording – Q1FY27",
        link: earningsCallRecordingQ1FY27,
        type: "audio",
      },

      {
        title: "Prior Intimation of Board Meeting",
        link: priorIntimationBoardMeeting,
      },
      {
        title: "Intimation of Analyst Meet June 10, 2026",
        link: IntimationofAnalystMeetJune,
      },
      {
        title: "Closure of Trading Window",
        link: ClosureofTradingWindow,
      },
      {
        title: "Certificate of RTA under Regulation 74(5)",
        link: CertificateofRTAunderRegulation,
      },
      {
        title: "Reconciliation of Share Capital Audit Report",
        link: ReconciliationofShareCapitalAuditReport,
      },
      {
        title: "Integrated Corporate Governance",
        link: "/integrated-corporate-governance-26-2027.html",
        type: "external",
      },
      {
        title: "Shareholding Pattern",
        link: "/shareholding-pattern-26-2027.html",
        type: "external",
      },
      {
        title: "Media Analyst Briefing Note",
        link: MediaAnalystBriefingNote2026,
      },
    ],
  },
];

const financialPerformance2526 = [
  {
    id: 4,
    mainTitle: "Quarter 4",
    data: [
      {
        title: "Outcome of Board Meeting - May 15, 2026",
        link: outcomeOfBoardMeeting2026,
      },
      {
        title: "Financial Results",
        link: financialResults2026,
      },
      {
        title: "Final Monitoring Agency Report",
        link: finalMonitoringAgencyReport,
      },
      {
        title: "Press Release – May 15, 2026",
        link: pressReleaseMay152026,
      },
      {
        title: "Newspaper Publication – Audited Financial Results",
        link: newspaperPublicationAuditedFinancialResults,
      },
      {
        title: "Q4- Investor Presentation",
        link: Q4_Investor_Presentation,
      },
      {
        title: "Earnings Call Audio Recording_Q4 FY26",
        link: earningsCallAudioRecording_Q4FY26,
        type: "audio",
      },
      {
        title: "Intimation of analyst meet- March 04, 2026",
        link: TradingWindowClosure2026,
      },
      {
        title: "Credit Rating March 24, 2026",
        link: CreditRatingMar24_2026,
      },
      {
        title: "Acquisition in Serentica India 33 Private Limited",
        link: AcqSerentica2026,
      },
      {
        title: "Completion of Phase I Ramp-Up at Punjab Facility",
        link: Phase1RampUp2026,
      },
      {
        title: "Certificate of RTA under Regulation 74(5)",
        link: CertRTAReg74_2026,
      },
      {
        title: "Reconciliation of Share Capital Audit",
        link: ReconShareCapAudit2026,
      },
      {
        title: "Shareholding Pattern",
        link: "/shareholding-pattern-2026.html",
        type: "external",
      },
      {
        title: "Integrated Corporate Governance",
        link: "/integrated-corporate-governance-2026.html",
        type: "external",
      },
      {
        title: "Prior Intimation of Board Meeting",
        link: PriorIntimationBM2026,
      },
      {
        title: "Intimation of Earnings Call",
        link: IntimationEarningsCall2026,
      },
    ],
  },
  {
    id: 3,
    mainTitle: "Quarter 3",
    data: [
      {
        title: "Credit Rating December 29, 2025",
        link: CreditRatingDec29_2025,
      },
      {
        title: "Q3 Shareholding Pattern",
        link: "/q3-shareholding-pattern.html",
        type: "external",
      },
      {
        title: "Investors Meeting Intimation",
        link: STLinvestorsMeet19022026,
      },
      {
        title: "Earnings Call_Audio Recording_Q3 FY26",
        link: earningsCallAudioRecording_3FY26,
        type: "audio",
      },
      {
        title: "Press Release - Q3 FY 25",
        link: PressReleaseQ3FY25,
      },
      {
        title: "Intimation on closure of Trading Window",
        link: intimationOnClosureofTradingWindow,
      },
      {
        title: "Certificate under 74 (5)",
        link: certificateUnder74,
      },
      {
        title: "Intimation of Board Meeting",
        link: IntimationOfBoardMeetingQ3FY,
      },
      {
        title: "Intimation of Earnings Call",
        link: IntimationOfEarningsCallQ3FY,
      },
      {
        title: "Intimation of Analyst Meet",
        link: IntimationOfAnalystMeet,
      },
      {
        title: "Outcome of Board Meeting-February 06, 2026",
        link: OutcomeOfBoardMeeting_Feb,
      },
      {
        title: "Financial Results",
        link: FinancialResults,
      },
      {
        title: "Monitoring Agency Report",
        link: MonitoringAgencyReport,
      },
      {
        title: "Intimation of Schedule of Analysts-November 24, 2025",
        link: finanQu3FileOne,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 2",
    data: [
      {
        title: "Earnings Call Transcript",
        link: finanQu2EarCallTrans,
      },
      {
        title: "Shareholding Pattern",
        link: finanQu3FileTwo,
      },
      {
        title: "Outcome of Board Meeting",
        link: quarter2_2526_10,
      },
      {
        title: "Investor Presentation",
        link: quarter2_2526_11,
      },
      {
        title: "ICRA Monitoring Agency Report",
        link: quarter2_2526_12,
      },
      {
        title: "Intimation of Newspaper Advertisement",
        link: quarter2_2526_13,
      },
      {
        title: "Earnings Call recording September 2025",
        link: quarter2_2526_14,
        type: "audio",
      },
      {
        title: "Press Release-September 2025",
        link: quarter2_2526_15,
      },
      {
        title: "Intimation of schedule of Analyst-August 12, 2025",
        link: quarter2_2526_1,
      },
      {
        title: "Intimation of schedule of Analyst-September 04, 2025",
        link: quarter2_2526_2,
      },
      {
        title: "Intimation of trading window closure",
        link: quarter2_2526_3,
      },
      {
        title: "Intimation of schedule of Analyst-October 03, 2025",
        link: quarter2_2526_4,
      },
      {
        title: "Certificate of RTA under 74(5)",
        link: quarter2_2526_5,
      },
      {
        title: "Integrated Corporate Governance",
        link: quarter2_2526_6,
      },
      // {
      //   title: "Shareholding Pattern",
      //   link: quarter2_2526_7,
      // },
      {
        title: "Intimation of Board Meeting",
        link: quarter2_2526_8,
      },
      {
        title: "Intimation of Earnings Call",
        link: quarter2_2526_9,
      },
    ],
  },
  {
    id: 1,
    mainTitle: "Quarter 1",
    data: [
      {
        title: "Intimation of Newspaper Advertisement",
        link: quarter2526_1,
        iconTop: "true",
      },
      {
        title: "Earnings Call Transcript",
        link: quarter2526_2,
        iconTop: "true",
      },
      {
        title: "Intimation of Commencement of Commercial Production in Punjab",
        link: CommencementProductionPunjab,
        iconTop: "true",
      },
      {
        title: "Intimation of Schedule of Analyst-June 10, 2025",
        link: STLInvestorsMeetJune10,
      },
      {
        title: "Intimation of Schedule of Analyst",
        link: STLInvestorsMeet11062025,
      },
      {
        title: "Intimation of Schedule of Analyst-June 12, 2025",
        link: STLInvestorsMeetJune12,
      },
      {
        title: "Intimation of Schedule of Analyst- June 25, 2025",
        link: STLInvestorsMeetJune25,
      },
      {
        title: "Intimation of Trading Window closure",
        link: STLTradingWindowclosureintimation,
      },
      {
        title: "Certificate of RTA under 74(5)",
        link: STLCertificateReg74,
      },
      {
        type: "external",
        title: "Integrated Corporate Governance",
        link: "/integrated-corporate-governance.html",
      },
      {
        type: "external",
        title: "Shareholding Pattern",
        link: "/shareholding-pattern.html",
      },
      {
        title: "ICRA Monitoring Agency Report",
        link: STLMonitoringagencyreport,
      },
      {
        title: "Intimation of Board Meeting",
        link: STLBMIntimation07082025,
      },
      {
        title: "Outcome of Board Meeting",
        link: STLBMOutcome07082025,
      },
      {
        title: "Intimation of Earnings Call",
        link: STLCoverLetterforEarningsCall,
      },
      {
        title: "Investor Presentation",
        link: STLInvestorpresentation,
      },
      {
        title: "Earnings Call Recording June 2025",
        link: callRec10034845,
        type: "audio",
      },
      //   {
      //     title: "Annual Secretarial Compliance Report ",
      //     link: "https://nsearchives.nseindia.com/corporate/SANATHAN_17052025154615_Final_Cover_Letter_with_DVD_Report_2025.pdf",
      //     type: "external",
      //   },
    ],
  },
];

const financialPerformance2425 = [
  {
    id: 1,
    mainTitle: "Quarter 4",
    data: [
      // {
      //   title: "Website Filings",
      //   link: finanQu4WebsiteFilings,
      // },
      {
        title: "Earnings call Presentation May 2025",
        link: "https://nsearchives.nseindia.com/corporate/SANATHAN_27052025143005_Cover_Letter_with_Investor_Presentation_March_2025.pdf",
        type: "external",
      },
      {
        title: "STL March 2025 Earnings Call Transcript",
        link: Sanathan_STL_Cover,
      },
      {
        title: "Earnings Call Recording March 2025",
        link: earningsCall2025,
        type: "audio",
      },
      {
        title: "Intimation of Schedule of Analyst – February 24, 2025",
        link: "https://nsearchives.nseindia.com/corporate/SANATHAN_19022025165606_STL__Investor_meet_Intimation.pdf",
        type: "external",
      },
      {
        title: "Intimation of Schedule of Analyst – March 04, 2025",
        link: "https://nsearchives.nseindia.com/corporate/SANATHAN_27022025192701_STL__Investor_meet_04032025.pdf",
        type: "external",
      },
      {
        title: "Update of change of CIN",
        link: "https://nsearchives.nseindia.com/corporate/SANATHAN_04032025140201_STL_Letter_for_Intimation_of_CIN_Update_04032025.pdf",
        type: "external",
      },
      {
        title: "Intimation of Schedule of Analyst – Multiple dates",
        link: "https://nsearchives.nseindia.com/corporate/SANATHAN_12032025144644_STL_Investors_Meet17032025.pdf",
        type: "external",
      },
      {
        title: "Investor Presentation March 2025",
        link: "https://nsearchives.nseindia.com/corporate/SANATHAN_18032025112613_STL_Investors_Presentation_signed.pdf",
        type: "external",
      },
      {
        title: "Intimation of Schedule of Analyst –March 27, 2025",
        link: "https://nsearchives.nseindia.com/corporate/SANATHAN_24032025165301_STL_Investors_Meet27032025_signed.pdf",
        type: "external",
      },
      {
        title: "Intimation of Schedule of Analyst –March 28, 2025",
        link: "https://nsearchives.nseindia.com/corporate/SANATHAN_26032025182827_STL_Investors_Meet28032025.pdf",
        type: "external",
      },
      {
        title: "Update on Credit Rating",
        link: "https://nsearchives.nseindia.com/corporate/SANATHAN_07042025180706_STLCreditLetterCombinedsigned.pdf",
        type: "external",
      },
      {
        title: "Certificate of RTA under 74(5) ",
        link: "https://nsearchives.nseindia.com/corporate/SANATHAN_08042025175217_STLCertificateunderReg74_5_.pdf",
        type: "external",
      },
      {
        title: "Shareholding Pattern Filing ",
        link: "https://www.nseindia.com/get-quotes/equity?symbol=SANATHAN",
        type: "external",
      },
      {
        title: "Intimation of ESOP Exercise Price ",
        link: "https://nsearchives.nseindia.com/corporate/SANATHAN_22042025194342_STL_Intimation_Reg_30.pdf",
        type: "external",
      },
      {
        title: "Integrated Corporate Governance Filing",
        link: "https://nsearchives.nseindia.com/corporate/ixbrl/INTEGRATED_FILING_GOVERNANCE_88042_29042025175715_iXBRL_WEB.html",
        type: "external",
      },
      {
        title: "Disclosure of Large Corporate ",
        link: "https://www.bseindia.com/xml-data/corpfiling/AttachHis/251a78b6-fec1-46a1-933e-19325a65d648.pdf",
        type: "external",
      },
      {
        title: "ICRA Monitoring Agency Report ",
        link: "https://nsearchives.nseindia.com/corporate/SANATHAN_14052025104709_F_ICRA_Cover_Letter_for_Monitoring_Agency_March_2025.pdf",
        type: "external",
      },
      {
        title: "Annual Secretarial Compliance Report ",
        link: "https://nsearchives.nseindia.com/corporate/SANATHAN_17052025154615_Final_Cover_Letter_with_DVD_Report_2025.pdf",
        type: "external",
      },
      {
        title: "Intimation under Reg 30 (ESOP)",
        link: finanQu4STLIntimationReg30,
      },
      {
        title: "Intimation of Trading Window closure",
        link: finanQu4StlMagazineMar25,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 3",
    data: [
      {
        title: "Investor Presentation",
        link: finanQu3StlSigned,
      },
      {
        title: "Investors Meet Intimation",
        link: finanQu3StlInvest,
      },
      {
        title: "Earnings Call Transcript",
        link: finanQu3EarningsTrans,
      },
      {
        type: "audio",
        title: "Earnings Call Recording",
        link: finanQu3EarningsCall,
      },
      {
        title: "Intimation of Board Meeting",
        link: finanQu3board,
      },
      {
        title: "Intimation of Earnings Call",
        link: finanQu3InvestorMeet,
      },
      {
        title: "Outcome of Board Meeting",
        link: finanQu3OutCome,
      },
      {
        title: "Press Release",
        link: finanQu3Press,
      },
      {
        title: "Statement of deviation of Variation",
        link: finanQu3Statement,
      },
    ],
  },
  {
    id: 3,
    mainTitle: "Quarter 2",
    data: [
      {
        title: "Intimation of Board Meeting",
        link: finanQu2File1,
      },
      {
        title: "Intimation of Earnings Call",
        link: finanQu2File2,
      },
      {
        title: "Outcome of Board Meeting",
        link: finanQu2File3,
      },
      {
        title: "Press Release",
        link: finanQu2File4,
      },
      {
        type: "audio",
        title: "Earnings Call Recording",
        link: earningsCall,
      },
      {
        title: "Earnings Call Transcript",
        link: finanQu2File6,
      },
    ],
  },
];

const financialPerformance2324 = [
  {
    id: 1,
    mainTitle: "Quarter 4",
    data: [
      {
        title: "STL Financials June 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2022",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 3",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 2",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 1",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
];

const financialPerformance2223 = [
  {
    id: 1,
    mainTitle: "Quarter 4",
    data: [
      {
        title: "STL Financials June 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2022",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 3",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 2",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 1",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
];

const financialPerformance2122 = [
  {
    id: 1,
    mainTitle: "Quarter 4",
    data: [
      {
        title: "STL Financials June 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2022",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 3",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 2",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 1",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
];

const financialPerformanceTab2425 = [
  {
    id: 1,
    mainTitle: "Quarter 4",
    data: [
      {
        title: "STL Financials June 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2022",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 3",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 2",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 1",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
];

const financialPerformanceTab2324 = [
  {
    id: 1,
    mainTitle: "Quarter 4",
    data: [
      {
        title: "STL Financials June 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2022",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 3",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 2",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Quarter 1",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
];

const yearTab = [
  {
    year: 2026,
    data: financialPerformance2627,
  },
  {
    year: 2025,
    data: financialPerformance2526,
  },
  {
    year: 2024,
    data: financialPerformance2425,
  },
  // {
  //   year: 2023,
  //   data: financialPerformance2324,
  // },
  // {
  //   year: 2022,
  //   data: financialPerformance2223,
  // },
  // {
  //   year: 2021,
  //   data: financialPerformance2122,
  // },
];

const FinancialPerformance = () => {
  const [isActivTab, setIsActivTab] = useState("quarterly");
  const [activeKey, setActiveKey] = useState("left-0");
  const [activeKeyTab2, setActiveKeyTab2] = useState("lefttab-0");
  const { width } = useWindowDimensions();
  const location = useLocation();
  const history = useHistory();
  const [targetScrollId, setTargetScrollId] = useState(null);
  const [activeAnnualAccordion, setActiveAnnualAccordion] = useState("0");

  const [activeYear, setActiveYear] = useState(2026);

  const selectedYearData = yearTab.find(({ year }) => year == activeYear);

  const tabListBottom = tabBottomData.map((tab, i) => (
    <NavLink
      className="tab_name"
      activeClassName="active"
      exact
      to={tab.link}
      key={`tab-${i}`}
    >
      <span className="tab_text">{tab.title}</span>
    </NavLink>
  ));

  const tabListTop = tabTopData.map((tab, i) => (
    <NavLink
      className="tab_name"
      activeClassName="active"
      exact
      to={tab.link}
      key={`tab-${i}`}
    >
      <span className="tab_text">{tab.title}</span>
    </NavLink>
  ));

  // useEffect(() => {
  //   const hash = window.location.hash;
  //   if (hash) {
  //     const targetId = hash.substring(1);
  //     const targetSection = document.getElementById(targetId);
  //     if (targetSection) {
  //       setTimeout(() => {
  //         const offset = 100; // Gap from viewport top
  //         const targetPosition =
  //           targetSection.getBoundingClientRect().top + window.scrollY - offset;
  //         window.scrollTo({ top: targetPosition, behavior: "smooth" });
  //         // targetSection.scrollIntoView({ behavior: "smooth" });
  //       }, 0);
  //       // history.replace("/investor-relations/investor-meet-presentation");
  //       history.replace(location.pathname);
  //     }
  //   }
  // }, [location]);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const targetId = hash.substring(1);

      // If it's 2024-2025, switch tab and wait to scroll
      const annualTabs = ["2024-25", "2025-26"];
      // if (targetId === "2024-25") {
      if (annualTabs.includes(targetId)) {
        setIsActivTab("annual");
        setTargetScrollId(targetId); // delay scroll until tab content loads

        // Find the index of the accordion to open based on URL hash
        const accordionIndex = financialPerformanceAnual.findIndex(
          (item) => item.url === targetId
        );

        if (accordionIndex !== -1) {
          setActiveAnnualAccordion(accordionIndex.toString());
        }
      } else {
        const targetSection = document.getElementById(targetId);
        if (targetSection) {
          setTimeout(() => {
            const offset = 100;
            const targetPosition =
              targetSection.getBoundingClientRect().top +
              window.scrollY -
              offset;
            window.scrollTo({ top: targetPosition, behavior: "smooth" });
          }, 100);
          history.replace(location.pathname);
        }
      }
    }
  }, [location]);

  // 👇 this effect runs *after* tab switch
  useEffect(() => {
    if (isActivTab === "annual" && targetScrollId) {
      const targetSection = document.getElementById(targetScrollId);
      if (targetSection) {
        setTimeout(() => {
          const offset = width > 767 ? 350 : 200;
          const targetPosition =
            targetSection.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: targetPosition, behavior: "smooth" });
        }, 100);
        history.replace(location.pathname);
        setTargetScrollId(null); // reset
      }
    }
  }, [isActivTab, targetScrollId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MetaDecorator
        canonicalLink={window.location.href}
        metaTitle="Explore Quarterly & Monthly Financial Performance | Sanathan Textiles"
        metaDesc="Stay updated with Sanathan Textiles' quarterly and monthly financial performance. Explore detailed reports and insights for informed investment decisions."
      />

      <section className="fin_perf_sec1 investor_relations">
        <div className="wrapper">
          <div className="breadcrumb_styles">
            <Link to="/" className="breadcrumb_link">
              Home
            </Link>{" "}
            {">"} Investor Relations
          </div>
          <div className="left_section">
            <h2 className="hollow_title">Investor Relations</h2>
            <div className="dash_wrapper">
              <Dash />
            </div>
            {/* <h3></h3> */}
            {/* <p>
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed diam voluptua. At vero eos et accusam et justo duo
              dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
              sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit
              amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
              invidunt ut labore et dolore magna aliquyam erat, sed diam
              voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
              Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum
              dolor sit amet.
            </p> */}
          </div>
          <div className="right_section">
            <figure className="bg_img">
              <img src={InvestorBgImg} alt="sanathan img" />
            </figure>
            <figure className="fg_img">
              <img src={InvestorFgImg} alt="sanathan img" />
            </figure>
            <div className="box_stock_hold">{width >= 769 && <Stock />}</div>
          </div>
          {/* mobile section for image*/}
          <div className="mobile_section">
            <figure className="mob_bg_img">
              <img
                className="mob_img1"
                src={InvestorBgImg}
                alt="sanathan img"
              />
            </figure>
            <figure className="mob_fg_img">
              <img src={InvestorFgImg} alt="sanathan img" />
            </figure>
          </div>
        </div>
      </section>
      <section className="stockWrapper stck_ivstor_rel">
        <div className="wrapper">{width <= 768 && <Stock />}</div>
      </section>
      <section className="fin_perf_sec2" id="financial">
        <div className="wrapper">
          <div className="row invest_row">
            <div className="col-md-4 invest_col">
              {width > 767 ? (
                <InvestTab />
              ) : (
                <div className="invest_tab_wrapper">{tabListTop}</div>
              )}
            </div>
            <div className="col-md-8 invest_col">
              <h1 className="heading">Financial Performance & Presentation</h1>
              <div className="row report_row">
                <div className="col-md-6 col-6 report_col report_tab_col">
                  <div className="report_tab_wrapper">
                    <h3
                      className={`report_tab_name ${
                        isActivTab === "quarterly" ? "active" : ""
                      }`}
                      onClick={() => setIsActivTab("quarterly")}
                    >
                      Quarterly
                    </h3>
                  </div>
                </div>
                <div className="col-md-6 col-6 report_col report_tab_col">
                  <div className="report_tab_wrapper">
                    <h3
                      className={`report_tab_name ${
                        isActivTab === "annual" ? "active" : ""
                      }`}
                      onClick={() => setIsActivTab("annual")}
                    >
                      Annual
                    </h3>
                  </div>
                </div>
              </div>
              {/* Year Tab */}
              {isActivTab === "quarterly" &&
                (width > 767 ? (
                  <div className="row report_row">
                    {yearTab?.map(({ year }) => (
                      <div className="col-md-2 col-4 report_col year-tab report_tab_col select">
                        <div className="report_tab_wrapper">
                          <h3
                            className={`report_tab_name ${
                              activeYear === year ? "active" : ""
                            }`}
                            onClick={() => {
                              setActiveKey("left-0");
                              setActiveYear(year);
                            }}
                          >
                            {year}
                          </h3>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="row report_row year-dropdown-container">
                    <select
                      className="col-12 year-dropdown"
                      value={activeYear}
                      onChange={({ target }) => {
                        setActiveKey("left-0");
                        setActiveYear(target?.value);
                      }}
                    >
                      {yearTab?.map(({ year }) => (
                        <option value={year}>{year}</option>
                      ))}
                    </select>
                    <img className="select-arrow" src={investUpArrow} />
                  </div>
                ))}

              {isActivTab === "quarterly" && (
                <div className="row report_row">
                  <div className="col-md-12 report_col">
                    <h3 className="year">
                      {selectedYearData?.year} - {selectedYearData?.year + 1}
                    </h3>
                    <FinanceAcc
                      accData={selectedYearData?.data}
                      dwnIcon
                      activeKey={activeKey}
                      setActiveKey={setActiveKey}
                      columnKey="left"
                    />

                    {/* <div className="d-md-none d-block">
                      <h3 className="year">2025 - 2026</h3>
                      <FinanceAcc
                        accData={financialPerformance2526}
                        dwnIcon
                        activeKey={activeKey}
                        setActiveKey={setActiveKey}
                        columnKey="right"
                      />
                    </div> */}
                    {/* <div className="d-md-block d-none">
                      <h3 className="year">2024 - 2025</h3>
                      <FinanceAcc
                        accData={financialPerformance2425}
                        dwnIcon
                        activeKey={activeKey}
                        setActiveKey={setActiveKey}
                        columnKey="left01"
                      />
                    </div> */}
                  </div>

                  {/* <div className="col-md-12 report_col">
                    <h3 className="year">2026 - 2027</h3>
                    <FinanceAcc
                      accData={financialPerformance2627}
                      dwnIcon
                      activeKey={activeKey}
                      setActiveKey={setActiveKey}
                      columnKey="left"
                    />
                    <div className="d-md-none d-block">
                      <h3 className="year">2025 - 2026</h3>
                      <FinanceAcc
                        accData={financialPerformance2526}
                        dwnIcon
                        activeKey={activeKey}
                        setActiveKey={setActiveKey}
                        columnKey="right"
                      />
                    </div>
                    <div className="d-md-block d-none">
                      <h3 className="year">2024 - 2025</h3>
                      <FinanceAcc
                        accData={financialPerformance2425}
                        dwnIcon
                        activeKey={activeKey}
                        setActiveKey={setActiveKey}
                        columnKey="left01"
                      />
                    </div>
                  </div> */}

                  {/* <div className="col-md-12 report_col">
                    <div className="d-md-block d-none">
                      <h3 className="year">2025 - 2026</h3>
                      <FinanceAcc
                        accData={financialPerformance2526}
                        dwnIcon
                        activeKey={activeKey}
                        setActiveKey={setActiveKey}
                        columnKey="right"
                      />
                    </div>
                    <div className="d-md-none d-block">
                      <h3 className="year">2024 - 2025</h3>
                      <FinanceAcc
                        accData={financialPerformance2425}
                        dwnIcon
                        activeKey={activeKey}
                        setActiveKey={setActiveKey}
                        columnKey="left01"
                      />
                    </div>
                  </div> */}
                  {/* ------------------------------------- */}

                  {/* <div className="col-md-6 report_col">
                    <h3 className="year">2023 - 2024</h3>
                    <FinanceAcc
                      accData={financialPerformance2324}
                      dwnIcon
                      activeKey={activeKey}
                      setActiveKey={setActiveKey}
                      columnKey="right"
                    />
                  </div>
                  <div className="col-md-6 report_col">
                    <h3 className="year">2022-2023</h3>
                    <FinanceAcc
                      accData={financialPerformance2223}
                      dwnIcon
                      activeKey={activeKey}
                      setActiveKey={setActiveKey}
                      columnKey="left01"
                    />
                  </div>
                  <div className="col-md-6 report_col">
                    <h3 className="year">2021-2022</h3>
                    <FinanceAcc
                      accData={financialPerformance2122}
                      dwnIcon
                      activeKey={activeKey}
                      setActiveKey={setActiveKey}
                      columnKey="right01"
                    />
                  </div> */}
                </div>
              )}
              {isActivTab === "annual" && (
                // <div className="row report_row">
                //   <div className="col-md-6 report_col">
                //     <h3 className="year">2024 - 2025</h3>
                //     <FinanceAcc
                //       accData={financialPerformanceTab2425}
                //       dwnIcon
                //       activeKey={activeKeyTab2}
                //       setActiveKey={setActiveKeyTab2}
                //       columnKey="lefttab"
                //     />
                //   </div>
                //   <div className="col-md-6 report_col">
                //     <h3 className="year">2023 - 2024</h3>
                //     <FinanceAcc
                //       accData={financialPerformanceTab2324}
                //       dwnIcon
                //       activeKey={activeKeyTab2}
                //       setActiveKey={setActiveKeyTab2}
                //       columnKey="righttab"
                //     />
                //   </div>
                // </div>
                <InvestAcc
                  accData={financialPerformanceAnual}
                  dwnIcon={width > 767 ? false : true}
                  activeAccordion={activeAnnualAccordion}
                  setActiveAccordion={setActiveAnnualAccordion}
                />
              )}
              {width <= 767 && (
                <div className="invest_tab_wrapper invest_tab_wrapper_2">
                  {tabListBottom}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FinancialPerformance;
